import { useQuery } from '@apollo/client';

import { LoaderOnWholeScreen } from '@/components/loaders/loader-on-whole-screen';
import { ToDoInfo } from '@/components/todo-page/todo-info';
import ToDoList from '@/components/todo-page/todo-list';
import { safeJsonParse } from '@/shared/utils/json';
import { MainWrap, PaddingWrap } from '@/styles/common';
import Header from '../header';
import { TODO_PAGE_ALLOCATION_TASKS_QUERY, TODO_PAGE_ALLOCATION_TASKS_REDIRECT_QUERY } from './queries';
import EmptyToDo from './todo-list/empty-todo';

export const ToDo = () => {
  const { loading: assignedToMeTaskLoading } = useQuery(TODO_PAGE_ALLOCATION_TASKS_REDIRECT_QUERY, {
    notifyOnNetworkStatusChange: true
  });

  const { data: allocationTasksData, loading: allocationTasksLoading } = useQuery(TODO_PAGE_ALLOCATION_TASKS_QUERY, {
    notifyOnNetworkStatusChange: true
  });

  if (allocationTasksLoading || assignedToMeTaskLoading) {
    return <LoaderOnWholeScreen size={60} />;
  }

  return (
    <MainWrap>
      <Header title="To Do List" />
      <PaddingWrap>
        <ToDoInfo data={allocationTasksData?.AllocationTasks || null} />
        {allocationTasksData?.AllocationTasks?.assignedToMeTaskCount === 0 &&
        allocationTasksData?.AllocationTasks?.ownedByMeNotAssignedToMeTaskCount === 0 ? (
          <EmptyToDo />
        ) : (
          <ToDoList data={safeJsonParse(allocationTasksData?.AllocationTasks?.investmentsSummary)} />
        )}
      </PaddingWrap>
    </MainWrap>
  );
};
